 const RAC_USDT_LPADDR = '0x9f3e1b10c58384ab472393455d2f870427ff9153'

 const RAC_USDT_PLEDGE_ADDR = '0xF787Fb34cd29f89C8A45f6b70D9592F2afbC0355'

 const RAC_ADDR = '0x024a9ad0ecfaa8b3566d3310affb358379a55e7a'

 export  { RAC_USDT_LPADDR, RAC_USDT_PLEDGE_ADDR, RAC_ADDR }